import { render, staticRenderFns } from "./versionMan.vue?vue&type=template&id=2befb3da&scoped=true"
import script from "./versionMan.vue?vue&type=script&lang=js"
export * from "./versionMan.vue?vue&type=script&lang=js"
import style0 from "./versionMan.vue?vue&type=style&index=0&id=2befb3da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2befb3da",
  null
  
)

export default component.exports